import { render, staticRenderFns } from "./OperationPermission.vue?vue&type=template&id=2e5e0df6&"
import script from "./OperationPermission.vue?vue&type=script&lang=js&"
export * from "./OperationPermission.vue?vue&type=script&lang=js&"
import style0 from "./OperationPermission.vue?vue&type=style&index=0&id=2e5e0df6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports